export default __webpack_public_path__ + "static/media/new8.3d3e40ef.png";